import { createPrefetchableAsyncDataContext, pageDataErrorHandler } from '#src/app/shared/contexts/asyncData';

import { getPsfPromoteOrSharePageData } from './api';
import type { PsfPromoteOrSharePageDataErrorCode } from './types';

/** @knip-ignore */
export const {
	Context: PsfPromoteOrSharePageDataContext,
	Provider: PsfPromoteOrSharePageDataContextProvider,
	useContext: usePsfPromoteOrSharePageData,
	useAsyncData: usePsfPromoteOrSharePageDataFromApi,
	prefetchAsyncData: prefetchPsfPromoteOrSharePageDataFromApi,
} = createPrefetchableAsyncDataContext({
	name: 'PsfPromoteOrSharePageDataContext',
	dataProperty: 'pageData',
	getData: getPsfPromoteOrSharePageData,
	getUniqueId: ({ slug, route }) => `${slug}:${route}`,
	hookDeps: ({ slug, route }) => [slug, route],
	errorHandler: pageDataErrorHandler<PsfPromoteOrSharePageDataErrorCode>(),
});
